function useQuery() {
  const url = new URL(window.location.href);
  return new URLSearchParams(url.search);
}

export { useQuery };
